import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

export const getBenchmarkMetricLabel = (
  benchmarkType: Portfolio['analysis']['benchmarkType'],
  benchmark: string
): string => {
  switch (benchmarkType) {
    case 'MARKET':
      return `${benchmark.toUpperCase()} Market`;
    case 'ETF':
      return `${benchmark.toUpperCase()} Index`;
    default:
      return benchmark.toUpperCase();
  }
};
